import * as React from 'react';
import { styled } from '@glitz/react';
import { createMaxMobileViewportDecorator, createMinLargeViewportDecorator } from 'webapp/viewport';
import { addSelectContentEventToDataLayer } from 'webapp/tracking/events/content';
import Link from 'webapp/components/Link';

export function DesignerCard(props: NordicNest.Api.SearchResultPageItemApiModel) {
  return (
    <Base
      to={props.url}
      onClick={() => addSelectContentEventToDataLayer({ id: props.id, type: 'designer_card', link: props.url })}
    >
      <Title>{props.name}</Title>
    </Base>
  );
}

/** @glitz-dynamic */
const Base = styled(
  Link,
  createMinLargeViewportDecorator({
    padding: { x: t => t.sharedSpacing.xl, y: t => t.sharedSpacing.l },
  }),
  {
    display: 'block',
    backgroundColor: t => t.monochrome.color,
    padding: { x: t => t.sharedSpacing.l, y: t => t.sharedSpacing.m },
  },
);

const Title = styled.h2(
  createMaxMobileViewportDecorator({
    fontSize: t => t.fontSize.xs,
  }),
  {
    fontSize: t => t.fontSize.s,
    fontWeight: 400,
    marginBottom: 0,
    lineHeight: 'normal',
    wordWrap: 'break-word',
    hyphens: 'auto',
  },
);
